<div class="mr-2" *ngIf="!configObject?.showIconViewMenu">
  <button mat-icon-button (click)="taskMenuTrigger.openMenu()" data-guided-tour-id="asset-menu-button">
    <mat-icon class="material-icons-outlined">more_vert</mat-icon>
    <div class="overlayMenu" matTooltip="Asset actions" #taskMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="assetActionMenu"></div>
  </button>
  <mat-menu #assetActionMenu="matMenu" yPosition="below" xPosition="before" [overlapTrigger]="false">
    <ng-container *ngTemplateOutlet="actionTemplate"></ng-container>
  </mat-menu>
</div>
<div class="mr-2" *ngIf="configObject?.showIconViewMenu">
  <ng-container *ngTemplateOutlet="actionTemplate"></ng-container>
</div>

<ng-template #actionTemplate>
  <!-- Default branding -->
  <div
    *ngIf="![CustomClients.Vorwerk, CustomClients.LufthansaMedialounge, CustomClients.LufthansaMediacenter, CustomClients.VKB, CustomClients.SEAT].includes(brandingKey)"
    #actions
    class="asset-gallery-actions-menu"
  >
    <thehubz-action-buttons
      [asset]="asset"
      [configObject]="configObject"
      [collectionOwner]="collectionOwner"
      [assetIndex]="assetIndex"
      (editAssets)="editAssets($event)"
      (downloadAsset)="downloadAsset.emit($event)"
      (deleteAsset)="deleteAsset.emit($event)"
      (shareAsset)="shareAsset($event)"
      (addToCollection)="addToCollection()"
      (removeFromCollection)="removeFromCollection($event)"
    ></thehubz-action-buttons>
  </div>
  <!-- Branding Vorwerk -->
  <div *ngIf="asset.status === Status.Draft && [CustomClients.Vorwerk].includes(brandingKey)" #actions class="asset-gallery-actions-menu">
    <ng-container *ngIf="screenSizeDetectorService.isLargeScreen">
      <button mat-menu-item (click)="updateDraftAsset()" *ngIf="AnyAsset | can: 'update'">
        <mat-icon class="material-icons-outlined">edit</mat-icon>
        <span i18n>Edit Asset</span>
      </button>

      <span class="cursor-pointer" *ngIf="!configObject?.hideDelete && (AccessAsset(asset) | can: 'delete')" i18n-matTooltip matTooltip="Delete">
        <button mat-menu-item [disabled]="asset.inProgress" (click)="deleteAsset.emit({ asset: asset, id: asset._id, planDeletionFlag: false })">
          <mat-icon>
            <span class="material-icons-outlined">delete_outline</span>
          </mat-icon>
          <span i18n>Delete asset</span>
        </button>
      </span>
    </ng-container>
  </div>
  <div
    *ngIf="
      asset.status !== Status.Draft && [CustomClients.Vorwerk, CustomClients.LufthansaMedialounge, CustomClients.LufthansaMediacenter, CustomClients.VKB, CustomClients.SEAT].includes(brandingKey)
    "
    #actions
    class="asset-gallery-actions-menu"
  >
    <thehubz-action-buttons
      [asset]="asset"
      [configObject]="configObject"
      [collectionOwner]="collectionOwner"
      [assetIndex]="assetIndex"
      (editAssets)="editAssets($event)"
      (downloadAsset)="downloadAsset.emit($event)"
      (deleteAsset)="deleteAsset.emit($event)"
      (shareAsset)="shareAsset($event)"
      (addToCollection)="addToCollection()"
      (removeFromCollection)="removeFromCollection($event)"
    ></thehubz-action-buttons>
  </div>
  <div #actions class="asset-gallery-actions-menu" *ngIf="configObject?.showIconViewMenu">
    <div *ngIf="brandingKey === CustomClients.WestLotto">
      <button *ngIf="configObject?.showPreviewButton" mat-icon-button class="cursor-pointer" type="button" (click)="viewAsset.emit(asset)">
        <mat-icon class="material-icons-outlined">{{ asset.assetType === 'Audio' ? '  hearing' : 'visibility' }}</mat-icon>
      </button>
      <button mat-icon-button class="cursor-pointer" type="button" (click)="downloadAsset.emit({ asset: asset, name: asset.mainFile.name })">
        <mat-icon class="material-icons-outlined">file_download</mat-icon>
      </button>
    </div>
    <div *ngIf="brandingKey !== CustomClients.WestLotto">
      <span class="cursor-pointer" *ngIf="asset.status !== Status.Draft && (AccessAsset(asset) | can: 'share') && (asset.expiryDate | dateNotExpired)">
        <button mat-icon-button [disabled]="asset.inProgress" (click)="shareAsset(asset)">
          <mat-icon>
            <span class="material-icons-outlined">share</span>
          </mat-icon>
          <span i18n>Share asset</span>
        </button>
      </span>
      <span class="cursor-pointer" *ngIf="!configObject?.hideDelete && (AccessAsset(asset) | can: 'delete')">
        <button mat-icon-button [disabled]="asset.inProgress" (click)="deleteAsset.emit({ asset: asset, id: asset._id })">
          <mat-icon>
            <span class="material-icons-outlined">delete_outline</span>
          </mat-icon>
          <span i18n>Delete asset</span>
        </button>
      </span>
      <span
        class="cursor-pointer"
        *ngIf="
          asset.status !== Status.Draft &&
          !configObject?.hideDownload &&
          (AccessAsset(asset) | can: 'download') &&
          ((asset.expiryDate | dateNotExpired) || (AccessAsset(asset) | can: 'expired.download'))
        "
      >
        <button mat-icon-button class="cursor-pointer" type="button" (click)="downloadAsset.emit({ asset: asset, name: asset.mainFile.name })">
          <mat-icon class="material-icons-outlined">file_download</mat-icon>
        </button>
      </span>
    </div>
  </div>
</ng-template>
